import React, { useState } from 'react';
import GoogleMapReact from 'google-map-react';
import '../App.css'

import Marker from './Marker';

import axios from 'axios';


const Map = (props) => {
    const [center, setCenter] = useState({lat: -33.857540, lng: 151.181000 });
    const [zoom, setZoom] = useState(13);
    const [coord, setCoord] = useState([])

    function fetchCoordinates(){
        axios
            .get(`/getCoord`)
            .then(res => {
                const newRead = res.data
                setCoord(coord => coord.concat(res.data))

            })
        }
        


    React.useEffect(() => {
            fetchCoordinates();
    }, [])
    const mark = coord.map(item =>  <Marker
        className='marker'
        key={item.key}
        lat={item.lat}
        lng={item.lng}
        name={item.name}
        color="red"/>)
    
    return (<div>
        <div style={{width: '100%', height: '100vh', overflow:'hidden'}} >

        <GoogleMapReact
          bootstrapURLKeys={{ key: 'AIzaSyAvTLj8gq3OcpfJDxAadOiBEW4_gCpkEWs' }}
          defaultCenter={center}
          defaultZoom={zoom}
        >
          {mark}
          
         
        </GoogleMapReact>
        
      </div>
      </div>
    );
}

export default Map;